export default __webpack_public_path__ + "assets/audios/8f41e2a7a08175238391e2ddab74624f.mp3";